// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ExpenseReportsPage = lazy(() => import('./pages/ExpenseReportsPage'));
const ReceiptOcrPage = lazy(() => import('./pages/ReceiptOcrPage'));
const ExpenseApprovalsPage = lazy(() => import('./pages/ExpenseApprovalsPage'));
const CategoryMappingPage = lazy(() => import('./pages/CategoryMappingPage'));
const PolicyEnforcementPage = lazy(() => import('./pages/PolicyEnforcementPage'));
const ReimbursementBatchesPage = lazy(() => import('./pages/ReimbursementBatchesPage'));

export const ExpensesRoutes: RouteObject = {
  path: 'expenses',
  element: <ModuleGuard moduleId="finance.expenses" />,
  children: [
    { path: 'expense-reports', element: <ExpenseReportsPage />, handle: { crumb: 'Expense Reports' } },
    { path: 'receipt-ocr', element: <ReceiptOcrPage />, handle: { crumb: 'Receipt Ocr' } },
    { path: 'expense-approvals', element: <ExpenseApprovalsPage />, handle: { crumb: 'Expense Approvals' } },
    { path: 'category-mapping', element: <CategoryMappingPage />, handle: { crumb: 'Category Mapping' } },
    { path: 'policy-enforcement', element: <PolicyEnforcementPage />, handle: { crumb: 'Policy Enforcement' } },
    { path: 'reimbursement-batches', element: <ReimbursementBatchesPage />, handle: { crumb: 'Reimbursement Batches' } },
  ],
};
